import { Button, Stack, Table, TableCell, TableRow, Typography } from '@mui/material';

import useUnitProvider from '/@/core/context/unit';
import { _ } from '/@/locale';
import type { YieldEstimationAPI } from '../..';

const YieldEstimationResult = ({
    yieldEstimation,
    goBack,
    onSave,
    saving = false,
    showSave = true,
}: {
    goBack: () => void;
    yieldEstimation: YieldEstimationAPI;
    /** Persist the estimation (create or update). Only invoked when `showSave`. */
    onSave: () => void;
    saving?: boolean;
    /** Show the "Guardar" action — only after the user has (re)run an estimation this session. */
    showSave?: boolean;
}) => {
    const units = useUnitProvider();

    return (
        <>
            <Stack p={3} borderBottom={(t) => `1px solid ${t.palette.divider}`} spacing={4} overflow={'scroll'}>
                <Stack spacing={1}>
                    <Typography color={'primary'} variant='subtitle1' fontWeight={'bold'}>
                        {_('Rendimiento estimado')}
                    </Typography>
                    <Typography color={'primary'} variant='h6'>
                        {units.toWeightPerArea(Number(yieldEstimation.result) || 0, 2).toString()}
                    </Typography>
                </Stack>

                <Stack spacing={3}>
                    <Typography color={'primary'} variant='subtitle2'>
                        {_('Rendimiento estimado')}
                    </Typography>
                    <Table
                        sx={{
                            fontSize: (t) => t.typography.body2.fontSize,
                            fontFamily: (t) => t.typography.body2.fontFamily,
                            color: (t) => t.palette.primary.main,
                            border: (t) => `1px solid ${t.palette.divider}`,

                            '& .MuiTableCell-root': {
                                fontFamily: (t) => t.typography.body2.fontFamily,
                            },
                        }}
                    >
                        <TableRow sx={{ '& .MuiTableCell-root': { fontWeight: 'bold' } }}>
                            <TableCell>{_('Muestra')}</TableCell>
                            <TableCell>{_('Nombre')}</TableCell>
                            <TableCell>{_('Rendimiento estimado')}</TableCell>
                        </TableRow>
                        {yieldEstimation.yieldSamples.map((el, index) => (
                            // biome-ignore lint/suspicious/noArrayIndexKey: fixed, non-reordered list; preview samples have no id
                            <TableRow key={index}>
                                <TableCell>{`${_('Muestra')} ${index + 1}`}</TableCell>
                                <TableCell>{el.name}</TableCell>
                                <TableCell>{units.toWeightPerArea(Number(el.result), 2).toString()}</TableCell>
                            </TableRow>
                        ))}
                    </Table>
                </Stack>
            </Stack>
            <Stack direction={'row'} justifyContent={'flex-end'} spacing={2} p={2}>
                <Button variant='text' color='primary' onClick={() => goBack()} disabled={saving}>
                    {_('Editar')}
                </Button>
                {showSave && (
                    <Button variant='contained' color='primary' onClick={onSave} disabled={saving}>
                        {_('Guardar')}
                    </Button>
                )}
            </Stack>
        </>
    );
};

export default YieldEstimationResult;
